// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const ManageTerminalList = () => import('@/modules/terminals/views/management/ManageTerminalList')


var routes = [
    {
        path: '/terminals/manage',
        redirect: '/terminals/manage/list',
        name: 'Manage Terminals',
        component: DefaultContainer,
        children: [
            {
                path: 'list',
                name: 'Terminal List',
                component: ManageTerminalList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];

export default routes;
